import getAdPlaying from "selectors/ads/getAdPlaying";
import getShowSlideshowGallery from "selectors/getShowSlideshowGallery";
import { createSelector } from "reselect";

const getDisableInactivity = (state) => state.playerOptions.disableInactivity;

const getUseInactivity = createSelector(
  [getAdPlaying, getDisableInactivity, getShowSlideshowGallery],
  (adPlaying, disableInactivity, showSlideshowGallery) =>
    !adPlaying && !showSlideshowGallery && !disableInactivity,
);

export default getUseInactivity;
